<div class="cards">
    <div class="row">
        <div class="col-md">
            <div class="card-item card-gradient tracker-card">
                <div class="card-content">
                    <small>Total Active and Inactive Partners</small>
                    <h4>{{ totalPartners$ | async }}</h4>
                </div>
                <img src="../../../../assets/okito/images/card-icons/users.svg" class="icon-size-56">
            </div>
        </div>
        <div class="col-md">
            <div class="card-item card-gray tracker-card">
                <div class="card-content">
                    <small>Total Active <span class="card-note">Have bookings</span></small>
                    <h4>{{ activePartners$ | async }}</h4>
                </div>
                <img src="../../../../assets/okito/images/card-icons/completed.svg" class="icon-size-56">
            </div>
        </div>
        <div class="col-md">
            <div class="card-item card-gray tracker-card">
                <div class="card-content">
                    <small>Total Inactive <span class="card-note">Online but no bookings</span></small>
                    <h4>{{ inactivePartners$ | async }}</h4>
                </div>
                <img src="../../../../assets/okito/images/card-icons/inactive.svg" class="icon-size-56">
            </div>
        </div>
    </div>
</div>